/* Routes for the releases area (Area C: account). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [{ path: 'releases/*', lazy: page(() => import('./pages/ReleasesPage')) }],
}
